/**
 * Dispatch UI tokens shared across daily dispatch surfaces (summary strip, scope cards).
 */

/**
 * Visual muted treatment when `DayDetails.locked` is true for that calendar column.
 * Tailwind utility strings — change here to retheme locked dispatch chrome consistently.
 */
export const DISPATCH_DAY_LOCKED_UI = Object.freeze({
  /** Summary column card: fades the full DayDetails content when locked. */
  summaryMutedClass: "opacity-60",
  /** Scope summary strip and edit-scope card surfaces when that aspect’s day is locked. */
  scopeCardMutedClass: "opacity-60",
});
